// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "/*\n * SocialMedia css File\n*/\n.SocialMedia {\n  /* propertys here */\n}", "",{"version":3,"sources":["webpack://src/Components/SocialMedia/SocialMedia.scss"],"names":[],"mappings":"AAAA;;CAAA;AAIA;EACI,mBAAA;AAAJ","sourcesContent":["/*\n * SocialMedia css File\n*/\n\n.SocialMedia {\n    /* propertys here */\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
